import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '../../constants';
import { useAuth } from '../useAuth';
import dashboardController, {
  SalesDashboardJobSummary,
} from '../../services/api/dashboardController';

type AuthLike = { tokens?: { idToken?: { jwtToken?: string } } };

export const useSalesOrganizationJobs = (orgId: string) => {
  const auth = useAuth();
  const authToken = (auth as AuthLike)?.tokens?.idToken?.jwtToken ?? '';

  return useQuery<SalesDashboardJobSummary[]>({
    queryKey: QUERY_KEYS.SALES_ORGANIZATION_JOBS(orgId),
    queryFn: async () => {
      const response = await dashboardController.getSalesOrganizationJobs(
        orgId,
        authToken,
      );
      return response?.data?.jobs || [];
    },
    enabled: Boolean(orgId && authToken),
  });
};
